/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Green_Wolf_LookInputs */

const en_vast_green_wolf_look = /** @type {(inputs: Vast_Green_Wolf_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select time zone`)
};

const de_vast_green_wolf_look = /** @type {(inputs: Vast_Green_Wolf_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitzone auswählen`)
};

/**
* | output |
* | --- |
* | "Select time zone" |
*
* @param {Vast_Green_Wolf_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_green_wolf_look = /** @type {((inputs?: Vast_Green_Wolf_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Green_Wolf_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_green_wolf_look(inputs)
	return de_vast_green_wolf_look(inputs)
});